<template>
  <div>
    <a-form layout="inline">
      <a-form-item>
        <a-date-picker v-model="startDate" @change="onStartDate" class="margenEstilosDashboard" />
      </a-form-item>
      <a-form-item>
        <a-date-picker v-model="endDate" @change="onEndDate" class="margenEstilosDashboard"/>
      </a-form-item>
      <a-form-item>
        <a-input v-model="dni" class="margenEstilosDashboard" placeholder="Buscar por DNI"/>
      </a-form-item>
      <br>
      <a-form-item>
        <a-button class="margenEstilosDashboard" @click="loadData">Consultar</a-button>
        <a-button class="margenEstilosDashboard" @click="exportXLSX">Exportar</a-button>
      </a-form-item>
    </a-form>
    <ag-grid-vue style="height: 400px;" class="ag-theme-balham"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColumnDefs"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :pagination="true">
    </ag-grid-vue>
  </div>
</template>
<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import modulesType from '@/store/types/modules'
import moment from 'moment'
// import { TreeSelect } from 'ant-design-vue'
import { AgGridVue } from 'ag-grid-vue'

// const SHOW_PARENT = TreeSelect.SHOW_PARENT

const columns = [
  {
    headerName: 'ITEM',
    sortable: true,
    field: 'id',
    width: 60,
  }, {
    headerName: 'FECHA DE REGISTRO',
    sortable: true,
    field: 'fechaRegistro',
    width: 140,
  }, {
    headerName: 'DNI',
    sortable: true,
    field: 'numDocumento',
    width: 90,
  }, {
    headerName: 'NOMBRES Y APELLIDOS',
    sortable: true,
    field: 'nombres',
    width: 180,
  }, {
    headerName: 'CELULAR',
    sortable: true,
    field: 'telefono',
    width: 100,
  }, {
    headerName: 'CORREO',
    sortable: true,
    field: 'correo',
    width: 160,
  }, {
    headerName: 'DEPARTAMENTO',
    sortable: true,
    field: 'nombreDepartamento',
    width: 120,
  }, {
    headerName: 'PROVINCIA',
    sortable: true,
    field: 'provincia',
    width: 120,
  }, {
    headerName: 'DISTRITO',
    sortable: true,
    field: 'distrito',
    width: 120,
  }, {
    headerName: 'DIRECCION',
    sortable: true,
    field: 'direccion',
    width: 150,
  }, {
    headerName: 'MONTO',
    sortable: true,
    field: 'montoSolicitado',
    width: 150,
  }, {
    headerName: 'PLAZO',
    sortable: true,
    field: 'plazo',
    width: 150,
  }, {
    headerName: 'ANTIGUEDAD LABORAL',
    sortable: true,
    width: 160,
    field: 'antigLaboral1',
  }, {
    headerName: 'TIPO DE TRABAJO',
    sortable: true,
    field: 'condicionLaboral',
    width: 140,
  }, {
    headerName: 'AFP/ONP',
    sortable: true,
    field: 'afpOnp',
    width: 140,
  }, {
    headerName: 'RAZON SOCIAL',
    sortable: true,
    field: 'razonSocial',
    width: 140,
  }, {
    headerName: 'APROBADO',
    sortable: true,
    field: 'esApto',
    width: 100,
  },
]

export default {
  dependencies: ['DynamicCallService', 'GenericService'],
  name: 'Module',
  components: {
    AgGridVue,
  },
  data() {
    return {
      gridOptions: null,
      client: '',
      dni: '',
      rowData: null,
      columnDefs: null,
      startDate: moment(),
      fechaInicio: moment().format('YYYY-MM-DD'),
      endDate: moment(),
      selectedTo: moment().format('YYYY-MM-DD'),
      size: 'default',
    }
  },
  computed: {
    ...mapGetters({
      // endpointForList: modulesType.getters.get ,
      // endpointForExport: modulesType.getters.getEndpointForExport,
    }),
  },
  created() {
    this.setModule()
  },
  beforeMount() {
    this.gridOptions = {}
    this.columnDefs = columns
    this.defaultColumnDefs = {
      resizable: true,
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.loadData()
  },
  watch: {
    $route: 'setModule',
  },
  methods: {
    // moment,
    async setModule() {
      await this.$store.dispatch(modulesType.actions.setModule, {
        key: this.$route.params.key,
      })
    },
    async loadData() {
      try {
        this.gridApi.showLoadingOverlay()
        const data = await this.GenericService.get(`webmarketplace/list-sullana-reports?fechaInicio=${this.fechaInicio}&fechaFin=${this.selectedTo}&numDocumento=${this.dni}`)
        if (data) {
          this.rowData = data.map((d) => ({
            ...d,
            fechaRegistro: DateTime.fromISO(d.fechaRegistro).setZone('America/Lima').toFormat('yyyy-MM-dd hh:mm a'),
          }))
        } else {
          this.$notification.warning({
            message: 'Error',
            description: 'No hay registros en las fechas seleccionadas',
          })
          this.rowData = null
        }
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: err.message,
        })
      } finally {
        this.gridApi.hideOverlay()
      }
    },
    async exportXLSX() {
      const tkn = this.GenericService.axios.defaults.headers.common.Authorization.substring(7)
      window.open(`${process.env.VUE_APP_API_URL}/webmarketplace/download-sullana-reports?tkn=${tkn}&fechaInicio=${this.fechaInicio}&fechaFin=${this.selectedTo}&dni=${this.dni}`, '_blank')
    },
    onStartDate(date, dateString) {
      // console.log(dateString, 'fechaInicio')
      this.fechaInicio = dateString
      // console.log(this.fechaInicio, 'this.fechaInicio')
    },
    onEndDate(date, dateString) {
      // console.log(dateString, 'fechaFin')
      this.selectedTo = dateString
      // console.log(this.selectedTo, 'this.selectedTo')
    },
  },
}
</script>
<style>
.margenEstilosDashboard{
  margin-right:15px;
  margin-bottom: 10px;
}
.estiloTabla{
  size:"small";
}
</style>
